import { render, staticRenderFns } from "./MitVolumesList.vue?vue&type=template&id=3efe4fc3&scoped=true"
import script from "./MitVolumesList.vue?vue&type=script&lang=js"
export * from "./MitVolumesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe4fc3",
  null
  
)

export default component.exports